import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const CustomSelect = ({ control, name, label, rules, onchange, errors, placeholder, className, options }) => {
  console.log({ name });
  return (
    <div className={cn("col-span-1 flex flex-col gap-2 relative min-w-[150px]", className)}>
      {label && <label htmlFor={name}>{label}</label>}

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <select
            {...field}
            onChange={(e) => {
              field.onChange(e);
              onchange?.(e); // call external handler if provided
            }}
            defaultValue=""
            className="h-[52px] px-4 outline-none rounded-v-md w-full border border-[#ccc] appearance-none"
          >
            <option value="" disabled hidden>
              {placeholder || "انتخاب کنید ..."}
            </option>
            {options.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}
      />

      {/* Dropdown arrow */}
      <div className="pointer-events-none absolute top-1/2 translate-y-[50%] left-0 flex items-center px-2 text-gray-700">
        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>

      {/* Validation error */}
      {errors?.message && <span className="text-red-500 text-sm">{errors.message}</span>}
    </div>
  );
};

export default CustomSelect;
